import { useState } from 'react'
import { Input } from 'components/forms'
import Link from 'components/link'
import Spinner from 'shared/spinner'
import { FeedAdminOverride } from '../FeedAdminTools'

interface FeedAdminToolsVersion1Props {
  isFetchingFeed: boolean
  onSubmit: (overrides: FeedAdminOverride) => void
}

const FeedAdminToolsVersion1 = (props: FeedAdminToolsVersion1Props) => {
  const { isFetchingFeed, onSubmit } = props
  const [sessionOverride, setSessionOverride] = useState(undefined)

  return (
    <Input
      addonAfter={
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <Link
          onClick={() => {
            onSubmit({
              session: sessionOverride,
            })
          }}
        >
          {isFetchingFeed ? <Spinner inverse={false} size="small" /> : 'Go'}
        </Link>
      }
      help="Enter a session number, contentful feed item entry id, 'wbw', or 'priority' to preview the feed."
      label="Preview Feed"
      onChange={(e: any) => setSessionOverride(e.target.value)}
    />
  )
}

export default FeedAdminToolsVersion1
